import { differenceInCalendarDays } from 'src/app/utils/date.utils';
import { DeadlineFrequency } from './deadline-rules.model';

export { differenceInCalendarDays };

export function addCalendarDays(from: Date, days: number): Date {
  const result = new Date(from);
  result.setDate(result.getDate() + days);
  return result;
}

export function addWorkingDays(from: Date, days: number): Date {
  const result = new Date(from);
  let added = 0;
  while (added < days) {
    result.setDate(result.getDate() + 1);
    const dow = result.getDay();
    if (dow !== 0 && dow !== 6) {
      added++;
    }
  }
  return result;
}

export function getCurrentPeriodEnd(frequency: DeadlineFrequency): Date {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();

  switch (frequency) {
    case 'monthly': {
      return new Date(year, month + 1, 0);
    }
    case 'quarterly': {
      const currentQuarter = Math.floor(month / 3);
      const quarterEndMonth = currentQuarter * 3 + 2;
      return new Date(year, quarterEndMonth + 1, 0);
    }
    case 'semi-annual': {
      const half = month < 6 ? 0 : 1;
      const endMonth = half === 0 ? 5 : 11;
      return new Date(year, endMonth + 1, 0);
    }
    case 'annual': {
      return new Date(year, 12, 0);
    }
  }
}

export function getNextPeriodEnd(
  frequency: DeadlineFrequency,
  periodEnd: Date
): Date {
  const year = periodEnd.getFullYear();
  const month = periodEnd.getMonth();

  switch (frequency) {
    case 'monthly':
      return new Date(year, month + 2, 0);
    case 'quarterly':
      return new Date(year, month + 4, 0);
    case 'semi-annual':
      return month < 6 ? new Date(year, 12, 0) : new Date(year + 1, 6, 0);
    case 'annual':
      return new Date(year + 1, 12, 0);
  }
}

